import React, { FC } from 'react';
import { User as TUser } from 't2-graphql-types';
import { getShortDescriptionFromBody } from 't2-keystone/src/schema/Article/services/getShortDescription';
import Typo from '../Typography/Typo';
import { ArticleParentInfoContainer } from '../ArticleParentInfo/ArticleParentInfoContainer';
import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';
import { TArticleHighlight } from '../Highlight/types';

type TReplyToQuoteModalContentProps = {
  id: string;
  articleTitle: string;
  author: Pick<TUser, 'id' | 'name' | 'username'>;
  pickedHighlightData: TArticleHighlight;
  slug: string;
  coverImage?: TCloudinaryImageShape;
};

export const ReplyToQuoteModalContent: FC<TReplyToQuoteModalContentProps> = ({
  id,
  articleTitle,
  author,
  pickedHighlightData,
  slug,
  coverImage,
}) => (
  <div>
    <Typo variant="small-p" className="mb-6 !text-base">
      Write a new post to elaborate on or respond to the specific quote you've highlighted.
    </Typo>
    <div className="mb-6">
      <ArticleParentInfoContainer
        parentArticle={{
          id,
          title: articleTitle as string,
          shortDescription: getShortDescriptionFromBody(pickedHighlightData),
          slug,
          author,
          coverImage: coverImage as TCloudinaryImageShape,
        }}
        expandAll
        displayAsQuote
      />
    </div>
  </div>
);
